import React, { useState } from "react";
import { Form, Collapse, Card } from "antd";
import jsonfile from "./localexpenses.json";
import { useHistory } from "react-router-dom";
import { CisUI } from "../../../../util/CISUI";
import AdvancedSearch from "../../../../util/AdvancedSearch";
import "react-smart-data-table/dist/react-smart-data-table.css";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
// import moment from "moment";

const Panel = Collapse.Panel;

const RegionMonthlyReport = () => {
  const ref = React.createRef();
  const formRef = React.createRef();

  //   const [monthStart, setMonthStart] = useState("");
  //   const [reportClosed, setReportClosed] = useState(false);
  const [state, setState] = useState({
    reqURL: Config.apiserver + jsonfile.urls.monthly,
    filtervalue: "",
    reportTitle: "",
    reportData: [],
    totalContribution: 0,
    month: "",
    region: "",
    district: "",
    districts: [],
    districtData: [],
    contribution: [],
    expensesOffice: [],
    expensesMission: [],
    totalExpenses: 0,
    netTitheAfterExpense: 0,
    rdf: 0,
    retainRDF: 0,
    aidf: 0,
    NetTitheToNation: 0,
    missionOffering: 0,
    MinistryIncome: 0,
    Mckeowns: 0,
    InternalMissions: 0,
    NationalPrayer: 0,
    PENSOS: 0,
    netCashToNation: 0,
    region_id: 0,
    reportClosed: 0,
  });

  const history = useHistory();

  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
    let wkd = "";
    let wk = "";
    // let dt = "";
    const qs = Object.keys(values)
      .map((key) => {
        if (key === "date") {
          wk = formRef.current.getFieldValue("date");
          const dt = CisUI().ParseDateFormat(values[key]);
          return `${key}=${dt}`;
        } else if (key === "month") {
          wk = formRef.current.getFieldValue("month");
          // console.log("Selected Week : "+ wk);
          const mnts = CisUI().ParseDateFormatFromMonth(wk);
          //console.log(mnts);
          wkd = mnts;
          return `${key}=${mnts}`;
        } else {
          return `${key}=${values[key]}`;
        }
      })
      .join("&");

    const qsup = qs.replaceAll("undefined", "");
    //reqURL = reqURL+"/?"+qsup;
    history.push("?" + qsup);
    const newURL = Config.apiserver + jsonfile.urls.monthly + "?" + qsup;
    console.log("NEURL :" + newURL);
    console.log("Month : " + wkd);
    const dts = values["month"];
    //console.log("Dt : "+dts);
    //console.log("Selected Date : "+ moment(dts).format("MMMM YYYY"));
    const WKR = CisUI().getMonthNameTimeStamp(dts);
    const reportTitle = "Monthly Report For the month of " + WKR;
    // setMonthStart(moment(dts).format("YYYY-MM") + "-01");

    document.getElementById("loader").style.display = "block";
    axios
      .get(newURL)
      .then((res) => {
        console.log(res.data);
        document.getElementById("loader").style.display = "none";
        if (res.data.status === 1) {
          //console.log("Response : "+ res.data);
          const data = res.data.data;
          setState({
            reqURL: newURL,
            contribution: data.contribution,
            totalContribution: data.totalContribution,
            districts: data.districts,
            districtData: data.districtData,
            district: data.districts,
            region: data.region,
            reportTitle: reportTitle,
            month: CisUI().getMonthTitle(wkd),
            expenses: data.expenses,
            expensesOffice: data.expensesOffice,
            expensesMission: data.expensesMission,
            totalExpensesOffice: data.totalExpensesOffice,
            totalExpensesMission: data.totalExpensesMission,
            totalExpenses: data.totalExpenses,
            netTitheAfterExpense: data.netTitheAfterExpense,
            rdf: data.rdf,
            retainRDF: data.retainRDF,
            aidf: data.aidf,
            NetTitheToNation: data.NetTitheToNation,
            missionOffering: data.missionOffering,
            MinistryIncome: data.MinistryIncome,
            Mckeowns: data.Mckeowns,
            InternalMissions: data.InternalMissions,
            NationalPrayer: data.NationalPrayer,
            PENSOS: data.PENSOS,
            netCashToNation: data.netCashToNation,
            region_id: data.region_id,
            reportClosed: data.reportClosed,
          });

          //   if (data.reportClosed === 1) {
          //     setReportClosed(true);
          //   } else {
          //     setReportClosed(false);
          //   }
        }
      })
      .catch((error) => {
        console.log(error);
        document.getElementById("loader").style.display = "none";
      });
  };

  let searchView = "";
  if (jsonfile.has_search) {
    searchView = (
      <Card className="advance-search-card no-print">
        <Collapse accordion expandIconPosition="right" defaultActiveKey={["1"]}>
          <Panel header="Advance Search" key="1">
            <Form
              key={5}
              form={form}
              ref={formRef}
              {...CisUI().formItemLayout}
              name="advanced_search"
              className="ant-advanced-search-form"
              onFinish={onFinish}
            >
              {AdvancedSearch(jsonfile.input, "", 0, "month")}
            </Form>
          </Panel>
        </Collapse>
      </Card>
    );
  }

  const print = () => {
    // window.print();
    const token = localStorage.getItem("token") || "";
    window.open(
      Config.baseurl +
        "monthlyreportprint.html?url=" +
        encodeURIComponent(window.btoa(state.reqURL)) +
        "&filename=region_monthly_report&data=regionmonthlyData&subtitle=" +
        encodeURIComponent(state.reportTitle) +
        "&rptype=regionmonthlyreport" +
        "&token=" +
        encodeURIComponent(window.btoa(token)),
      "_blank",
    );
  };

  const listAction = () => (
    <div className="no-print">
      <a id="rploader" style={{ width: "40px", height: "40px", display: "none" }}>
        <img src="/assets/images/loader.svg" style={{ width: "40px", height: "40px" }} alt="loader" /> Please wait ...
      </a>

      <button onClick={print} className="btn btn-export-print btn-circle-md" title="Print">
        <i className="fas fa-print" />
      </button>
    </div>
  );

  const getExtra = <>{listAction()}</>;

  return (
    <>
      {searchView}
      <Card id="reportview" extra={getExtra}>
        {CisUI().showLoading}
        <div ref={ref}>
          <div className="row">
            <div className="text-right col-md-12" style={{ textAlign: "right" }}></div>
            <div className="text-center col-md-12">
              <h3>Monthly Area Report</h3>
              <h2>{state.reportTitle}</h2>
            </div>
            <div className="col-md-6">
              <strong>Month :</strong> {state.month}
              <div>
                <strong>Area :</strong> {state.region}
              </div>
              <div>
                <strong>NO. OF DISTRICTS :</strong> {state.districts.length}
              </div>
            </div>
            <div className="text-right col-md-6"></div>
          </div>
          <h4 style={{ marginTop: "20px" }}>District Income & Expenses</h4>
          <div className="table-responsive">
            <table className="table table-bordered report2">
              <thead>
                <tr>
                  <th style={{ width: "180px" }}>District</th>
                  {state.districtData.map((items, index) => (
                    <th style={{ textAlign: "right" }}>{items.title}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {state.districts.map((district, dIdx) => (
                  <tr key={dIdx}>
                    <td style={{ fontWeight: "bold", width: "180px" }}>{district.name}</td>
                    {state.districtData.map((items, index) => {
                      const val = items.districtData[dIdx] || 0;
                      const isMinus = items.type === "minus" || items.type === "minusBold";
                      const isBold = items.type === "total" || items.type === "minusBold";
                      return (
                        <td
                          key={index}
                          style={{
                            textAlign: "right",
                            fontWeight: isBold ? "bold" : "normal",
                          }}
                        >
                          {isMinus
                            ? "(" + CisUI().getCurrencyFormated1(val) + ")"
                            : CisUI().getCurrencyFormated1(val)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
                <tr style={{ fontWeight: "bold" }}>
                  <td>Total</td>
                  {state.districtData.map((items, index) => {
                    const isMinus = items.type === "minus" || items.type === "minusBold";
                    return (
                      <td key={index} style={{ textAlign: "right" }}>
                        {isMinus
                          ? "(" + CisUI().getCurrencyFormated1(items.total) + ")"
                          : CisUI().getCurrencyFormated1(items.total)}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
          </div>

          <h4>Area Income & Expenses</h4>
          <table className="table table-bordered report">
            <thead>
              <tr>
                <th>Title</th>
                <th style={{ textAlign: "right" }}>Amount</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>TOTAL CONTRIBUTION RECEIVED (Tithe & Offering)</th>
                <th style={{ textAlign: "right" }}></th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.totalContribution)}</th>
              </tr>

              <tr>
                <th>AREA EXPENSES</th>
                <th style={{ textAlign: "right" }}></th>
                <th style={{ textAlign: "right" }}></th>
              </tr>
              {state.expensesOffice.map((items, index) => {
                return (
                  <tr>
                    <td>{items.title}</td>
                    <td style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(items.amount)}</td>
                    <td style={{ textAlign: "right" }}></td>
                  </tr>
                );
              })}
              <tr>
                <th>Total Expenses</th>
                <th style={{ textAlign: "right" }}></th>
                <th style={{ textAlign: "right" }}>({CisUI().getCurrencyFormated1(state.totalExpenses)})</th>
              </tr>
              <tr>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  Net Tithe After AREA Expenses
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.netTitheAfterExpense)}</th>
              </tr>
              <tr>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  Less: AREA Development Fund (ADF : 10%)
                </th>
                <th style={{ textAlign: "right" }}>({CisUI().getCurrencyFormated1(state.rdf)})</th>
              </tr>

              <tr>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  Net Tithe to HQ
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.NetTitheToNation)}</th>
              </tr>
              <tr>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  Add : Missions Offering
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.missionOffering)}</th>
              </tr>
              <tr style={{ display: "none" }}>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  <a href="#">Add : Ministry Income</a>
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.MinistryIncome)}</th>
              </tr>
              <tr style={{ display: "none" }}>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  Add : Mckeowns
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.Mckeowns)}</th>
              </tr>
              <tr style={{ display: "none" }}>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  Add : Internal Missions
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.InternalMissions)}</th>
              </tr>
              <tr style={{ display: "none" }}>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  Add : National Prayer
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.NationalPrayer)}</th>
              </tr>
              <tr style={{ display: "none" }}>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  Add : PENSOS
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.PENSOS)}</th>
              </tr>
              <tr>
                <th colSpan={2} style={{ textAlign: "right" }}>
                  AMOUNT SENT TO HQ{" "}
                </th>
                <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(state.netCashToNation)}</th>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </>
  );
};

export default RegionMonthlyReport;
